import React from "react";


const Alerts = ({ msg, flag }) => (
    <div className='position-fixed'>
            {console.log('called',msg,flag)}

        <div className="animated slideInLeft" style={{ width: 'fit-content' }}>
            <link
                rel="stylesheet"
                href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
            />
            {flag === 'success' ?
                <div className=" alert-popup alert-success" >
                    <strong>{msg}</strong>
                </div>
                : ""}
            {flag === 'failure' ?
                <div className="alert-popup alert-danger">
                    <strong>{msg}</strong>
                </div>
                : ""}
        </div>
    </div>
)

export default Alerts